import { billableIntervalAnalyticAction } from "../actions/billableIntervalAnalyticAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountFilter: "",
  startDate: "",
  endDate: "",
  interval: "day_31",
};

const billableIntervalAnalyticSlice = createSlice({
  name: "billableIntervalAnalytic",
  initialState: initialState,
  reducers: billableIntervalAnalyticAction,
});

export const { changeFilter } = billableIntervalAnalyticSlice.actions;

export default billableIntervalAnalyticSlice.reducer;
